import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './styles/index.css';
import Home from './Home';
import reportWebVitals from './reportWebVitals';

const Epk = lazy(() => import('./components/Epk'));

const router = createBrowserRouter([
  {
    path: "/epk",
    element: (
      <Suspense fallback={<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#080913', color: 'white', fontFamily: 'var(--font-headings)' }}>Loading EPK...</div>}>
        <Epk />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <Home />,
  }
])


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <div className='global'>
      <RouterProvider router={router} />
    </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
